import { Carousel3D } from "./Carousel3D";
import { ecosystemModules } from "./ecosystemModules";
import { LanguageSwitcher } from "./LanguageSwitcher";
import logoWhite from "../../../assets/png/brand/logo-white.png";

// Cabecera compacta para móvil: logo + carrusel horizontal chico. La
// Brújula (radar) no tiene versión móvil propia (ver README del handoff),
// así que en mobile siempre se muestra el carrusel, sin importar qué
// variante haya tocado para el panel de escritorio.
export function EcosystemMobileHeader({ t }) {
  return (
    <div className="eco-mobile-header">
      <span className="eco-mobile-header__star" style={{ left: "14%", top: "12%", animationDuration: "4.5s" }} />
      <span className="eco-mobile-header__star" style={{ left: "80%", top: "20%", animationDuration: "5.5s", animationDelay: ".7s" }} />

      <div className="eco-mobile-header__top">
        <img src={logoWhite} alt="sustemia" className="eco-mobile-header__logo" />
        <LanguageSwitcher />
      </div>

      <div className="eco-mobile-header__carousel-wrap">
        <div className="eco-mobile-header__glow" />
        <div className="eco-mobile-header__carousel-tilt">
          <Carousel3D
            modules={ecosystemModules}
            axis="y"
            cardWidth={104}
            cardHeight={112}
            radius={195}
            duration={30}
            maskAxis="horizontal"
          />
        </div>
      </div>

      <div className="eco-mobile-header__bottom">
        <div>
          <div className="eco-mobile-header__kicker">{t("login_ecosystem_kicker")}</div>
          <div className="eco-mobile-header__heading">
            {t("login_ecosystem_title_1")}
            <span>{t("login_ecosystem_title_2")}</span>
          </div>
        </div>
        <span className="eco-mobile-header__count">{t("login_ecosystem_count")}</span>
      </div>
    </div>
  );
}
